module.exports = __webpack_public_path__ + "img/repositorio_unico_img1.bc728c43.jpg";